var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsAsideLayout',{scopedSlots:_vm._u([{key:"detailsContent",fn:function(){return [_c('CreateSystem',{attrs:{"tabs":_vm.tabs,"title":"Windows"}},[[_c('div',[_c('p',[_vm._v(" Secure your Windows devices by installing the JumpCloud Agent. "+_vm._s(_vm.installMethodsText)+" ")])])]],2)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }